import React from "react";
import "./Sponsorship.css";

const Sponsorship = () => {
  return (
    <div className="sponsorship_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vel, excepturi
        cum similique ratione vero ipsam earum. Et culpa maiores perspiciatis
        ratione molestias, reprehenderit, cupiditate saepe fugit, facere ducimus
        modi minus!
      </h1>
    </div>
  );
};

export default Sponsorship;
